import { AnagraficaReteAste, CacheOptions, AnagraficaError } from "@reteaste/reteaste-anagrafica-client";
import "./globals";
import $ from "jquery";
import { gotoHome } from "./utils";
//import {navigateTo} from "./utils";

let _api: AnagraficaReteAste | undefined = undefined;

const resetApi = () => { _api = undefined; }

const getApi = (): AnagraficaReteAste => {
    const useCookies = window.UseCookieCredentials !== false; // per default uso i cookie per le credenziali
    if (!_api) {
        _api = new AnagraficaReteAste(
            window.BaseUrlAnagrafica,
            window.WsAuthClientCode,
            {
                language: "it-IT",
                debug: true,
                useCookies: useCookies
            });
    }

    return _api;
}

interface ConsensoUtente {
    id: number,
    concesso: boolean,
    scaduto: boolean,
    obbligatorio: boolean,
    codice: string
}

interface Contatto {
    idContatto?: number,
    tipoContatto: string,
    idTipoContatto?: number,
    verificato: boolean,
    valore: string,
    prefisso?: string
}

interface Recapito {
    idRecapito?: number,
    tipoRecapito: string,
    codiceRecapito?: string,
    idTipoRecapito?: number,
    idStato?: number,
    idComune?: number,
    idProvincia?: number,
    cap?: string,
    indirizzo?: string,
    civico?: string,
    comuneEstero?: string,
    stato?: string,
    provincia?: string,
    comune?: string
}

interface UserInfo {
    isAuthenticated?: boolean,
    tokenType?: string,
    accessToken?: string,
    expiresIn?: number,
    refreshToken?: string
    anagraficaId?: number,
    nome?: string,
    cognome?: string,
    email?: string,
    userId?: string,
    codiceFiscale?: string,
    dataNascita?: Date,
    sesso?: "M" | "F" | null,
    idStatoNascita?: number,
    statoNascita?: string,
    idComuneNascita?: number,
    comuneNascita?: string,
    luogoNascitaEstero?: string,
    isEmailConfirmed?: boolean,
    isPasswordScaduta?: boolean,
    consensiIncompleti?: boolean,
    consensiScaduti?: boolean,
    cambioPassword?: boolean,
    consensi?: ConsensoUtente[],
    contatti?: Contatto[],
    recapiti?: Recapito[],
    cittadinanza?: string,
    loginProvider?: 'IdentitàDigitale' | null
}

const handleError = (err: any, callback?: (html: string) => void) => {
    let errHtml;
    // AnagraficaError
    if (typeof err === "object" && err.isAnagraficaError) {
        errHtml = err.toHtml();

    } else {
        errHtml = "<p class='auth-api-error'>Errore interno all'applicazione. Si prega di riprovare più tardi.</p>"; //TODO: i18n
        console.log(err);
    }

    if (typeof (callback) === "function") {
        callback(errHtml);
    }

    return errHtml;
}

const checkAuth = async (): Promise<any> => {



    // const auth = getApi();
    //
    // let profile = null;
    // const _display = (anaId: string, token : string) : void => {
    //     $(() => {
    //         //$("#loggedarea").hide();
    //         $( 
    //             "input[name='UserId']," +
    //             "input[name='userid']," +
    //             "input[name='userAnagraficaId']"
    //         ).val(anaId);
    //         $("input[name='token']").val(token); //TODO: valutare se serve. L'autorizzazione verso il backend dovrà essere gestita tramite cookie
    //     });
    // };

    let user = await userInfo() as UserInfo;

    return await userInfo() as UserInfo;
    //_display(userInfo.anagraficaId, userInfo.accessToken);
}


const login = async (username: string, password: string): Promise<UserInfo> => {
    const auth = getApi();
    try {
        let userInfo = await auth.login(username, password) as UserInfo;
        sessionStorage.removeItem("sessionTainted");
        auth.setCached("userInfo", userInfo, { bindAuth: true });
        await clearBackendSession();

        // setto le chiavi in localStorage per compatibilità.
        // si potranno rimuovere una volta risolte tutte le segnalazioni in console
        await setUserInfoCompat(userInfo);

        return userInfo;
    } catch (err) {
        let errHtml = handleError(err);
        console.log(errHtml);
        throw err;
    }

}

const setUserInfoCompat = async (userInfo: UserInfo): Promise<void> => {
    const auth = getApi();
    //localStorage.setItem('accessToken', (await auth.getUserTokens()).accessToken!);
    localStorage.setItem('userName', userInfo.email as string);
    localStorage.setItem('userId', userInfo.userId as string);
    localStorage.setItem('userEmail', userInfo.email as string);
    localStorage.setItem('userAnagraficaId', userInfo.anagraficaId!.toString());
    localStorage.setItem('passwordExpired', userInfo.isPasswordScaduta!.toString());
    localStorage.setItem('nome', userInfo.nome as string);
    localStorage.setItem('cognome', userInfo.cognome as string);
    //localStorage.setItem('ragionesociale', response.ragionesociale);
    localStorage.setItem('ATP', (!userInfo.consensiIncompleti).toString());
    //localStorage.setItem('RA', response.RA);
    if (userInfo.cambioPassword === false)
        localStorage.setItem('flag', 'ID'); //TODO: gestire lato anagrafica campo cambioPassword (true se il provider di auth ammette cambio password)
}

const clearUserInfoCompat = async (): Promise<void> => {
    localStorage.removeItem('userName');
    localStorage.removeItem('userId');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userAnagraficaId');
    localStorage.removeItem('passwordExpired');
    localStorage.removeItem('nome');
    localStorage.removeItem('cognome');
    localStorage.removeItem('ATP');
    localStorage.removeItem('flag');
}

const logout = async (home?: boolean): Promise<void> => {
    if (typeof home === "undefined") home = true;

    const auth = getApi();

    auth.clearCached("userMenu");
    auth.clearAllCached(true);

    // rimuoviamo le chiavi in localStorage per compatibilità.
    // si potranno rimuovere insieme alla setUserInfoCompat una volta risolte tutte le segnalazioni in console
    await clearUserInfoCompat();

    try {
        let _ = await Promise.all([
            clearBackendSession(),
            auth.logout()
        ]);
        if (home) await gotoHome();
    } catch (err) {
        sessionTainted(true);
    }
}


const userInfo = async (forceReload?: boolean): Promise<UserInfo> => {
    if (sessionTainted()) {
        return { isAuthenticated: false };
    }

    const auth = getApi();
    const _loader = function (options: CacheOptions): (() => Promise<any>) {
        options.bindAuth = false;
        return async function (): Promise<any> {
            let user = await auth.fetchWithAuth("GET /user/profile");
            if (user && user.isAuthenticated) options.bindAuth = true;

            return user
        };
    }

    if (forceReload) {
        auth.clearCached("userInfo");
    }
    let userInfo = await auth.getCachedAsync("userInfo", _loader);

    return userInfo as UserInfo;
}


const sessionTainted = function (tainted?: boolean): boolean | undefined {
    if (arguments.length == 0) {
        return sessionStorage.getItem("sessionTainted") === "true";
    }
    else {
        sessionStorage.setItem("sessionTainted", tainted ? "true" : "false");
        return tainted;
    }
}

const clearBackendSession = (): Promise<void> => {

    let _url = window.BaseUrlWeb + "Home/LogOut";

    return new Promise<void>((resolve, reject) => {
        $.ajaxWithCredentials({
            url: _url,
            type: "POST",
            contentType: "application/json; charset=utf-8"
        }).done(function () {
            resolve();
        }).fail(function (jqXHR, textStatus, errorThrown) {
            reject({ jqXHR, textStatus, errorThrown });
        });
    });
}

const maskOn = async (userId: string): Promise<void> => { // throws AnagraficaError
    const auth = getApi();
    const currentUser = await userInfo();
    const impersonatedUser = await auth.impersonate(userId);
    auth.setCached("impersonator", currentUser, { bindAuth: true });
    auth.setCached("userInfo", impersonatedUser, { bindAuth: true });
    await setUserInfoCompat(impersonatedUser); // rimuovere quando non serve più compatibilità con le vecchie versioni
    //   await clearBackendSession();
}

const getImpersonator = async (): Promise<UserInfo | null> => {
    return await getApi().getCachedAsync("impersonator");
}

const maskOff = async (): Promise<void> => {
    const auth = getApi();
    await auth.endImpersonation();
    const userInfo = await auth.fetchWithAuth("GET /user/profile");
    auth.setCached("userInfo", userInfo, { bindAuth: true });
    auth.clearCached("impersonator");
    await setUserInfoCompat(userInfo); // rimuovere quando non serve più compatibilità con le vecchie versioni
    //return clearBackendSession();
}

const isPasswordless = async () : Promise<boolean> => {
    const currentUser = await userInfo();
    if (currentUser.loginProvider === 'IdentitàDigitale') {
        return true;
    }
    
    return false;
}

export {
    resetApi,
    getApi,
    maskOn,
    maskOff,
    getImpersonator,
    handleError,
    login,
    logout,
    clearBackendSession,
    userInfo,
    isPasswordless,
    type UserInfo,
    type Contatto,
    type AnagraficaError
};